// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.00195 1.99805H6.99805V4.00195H9.00195V1.99805Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13.002 1.99805H10.998V4.00195H13.002V1.99805Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17.002 1.99805H14.998V4.00195H17.002V1.99805Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9 10V5H7V10H3V15H6.16228L9 15.9459L12 14.9459L15 15.9459L17.8377 15H21V10H17V5H15V10H13V5H11V10H9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 17H18.1623L15 18.0541L12 17.0541L9 18.0541L5.83772 17H3V20H1V22H23V20H21V17Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-cake-filled')
export default class CakeFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cake-filled',
    }
  }
}
